import { StrategyTable } from "fleet/view/overview/strategy-table";
import { connect } from "react-redux";
import { strategyStatsSelector } from "redux-store/ui-state/account-stats/selectors";

function mapStateToProps(state) {
  return {
    stats: strategyStatsSelector(state),
  };
}

const ConnectedStrategyTable = connect(mapStateToProps)(StrategyTable);

export { ConnectedStrategyTable };
